import { DynamicFormProps } from 'types';

export const getCommonFormProps = (onPass: (data: any, toDraft?: boolean) => void): DynamicFormProps => ({
  cancelCaption: 'Save To Draft',
  withFooter: true,
  buttonsShape: 'slimy',
  marginMode: 'low',
  onCancel: (data: any) => {
    onPass(data, true);
  },
});


export const getCommonStockProps = (onCancel: (data: any) => void): DynamicFormProps => ({
  cancelCaption: 'Cancel',
  withFooter: true,
  buttonsShape: 'slimy',
  marginMode: 'low',
  onCancel: onCancel,
});
